import React from 'react';

const OverDueStatus = () => {
    return (
        <div className="overdue-tag">
        
        </div>
    );
};

export default OverDueStatus;
